import React, { useState, useEffect } from "react";

function Time() {
    const [time, setTime] = useState(new Date().toLocaleTimeString());
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setTime(new Date().toLocaleTimeString());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) return null;

    const date = new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
    });

    return (
        <div className="leading-none m-0 text-[0.90rem] text-gray-400">
            {date}, {time}
        </div>
    );
}

export default Time;
